module.exports = __webpack_public_path__ + "img/technology-event-rot.08f62e7e.svg";